import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { bibleSource, OfflineState } from "../../../../../storage";

import { BibleListItem } from "../../ListItems";

const noOp = () => {};

let onCloudClick = undefined;
bibleSource().then(downloader => {
  if (!downloader.canCache()) return;

  onCloudClick = async (bibleId, offlineState) => {
    if (offlineState < OfflineState.failed) {
      await downloader.deepCacheBible(bibleId); // .then({bible, status} => ...)
    }
    // LATER: else if (offlineState === OfflineState.failed)       // give more error info and confirm retry, send feedback?
    // LATER: else if (offlineState === OfflineState.paused)       // resume OR stop and remove (confirm or side swipe or long touch instead?)
    // LATER: else if (offlineState === OfflineState.pending)      // pause
    // LATER: else if (offlineState === OfflineState.downloading)  // pause
    // LATER: else if (offlineState === OfflineState.local)        // remove
  };
});

export const List = styled.div`
  padding: 4px 0;
`;

export const BibleList = ({
  bibles = [],
  currentBible = {},
  onBibleClick = noOp,
  siteBibleIds
}) => (
  <List>
    {siteBibleIds
      .map(id => bibles.find(bible => bible.id === id))
      .map(bible => (
        <BibleListItem
          bible={bible}
          key={bible.id}
          active={currentBible.id === bible.id}
          onCloudClick={onCloudClick}
          onClick={() => onBibleClick(bible.id)}
        />
      ))}
  </List>
);

BibleList.propTypes = {
  bibles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired
    })
  ),
  onBibleClick: PropTypes.func.isRequired,
  currentBible: PropTypes.shape({
    id: PropTypes.string
  }),
  siteBibleIds: PropTypes.arrayOf(PropTypes.string)
};
